import classname from 'classnames';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import Icon from '@/componentsDS/Icon/Icon';

const MultiLayerHeader = ({ headers,
	sortConfig,
	onSort,
	groupBy,
	isTableCollapsed,
	toggleTableCollapse,
	stickyColumns,
	id = undefined
}) => {
	const getSortIcon = (headerKey) => {
		if (sortConfig.secondaryKey) {
			if (sortConfig.secondaryKey === headerKey) {
				return sortConfig.secondaryDirection === 'asc'
				? <Icon name="arrow-small-up" size="small" style="outlined" />
				: <Icon name="arrow-small-down" size="small" style="outlined" />;
			}

			return <Icon name="arrows-up-down" size="small" style="outlined" />;
		}

		if (sortConfig.primaryKey === headerKey) {
			return sortConfig.primaryDirection === 'asc'
				? <Icon name="arrow-small-up" size="small" style="outlined" />
				: <Icon name="arrow-small-down" size="small" style="outlined" />;
		}

		return <Icon name="arrows-up-down" size="small" style="outlined" />;
	};

	const collapsibleClass = classname({
		'ds-multi-layer-table__th ds-multi-layer-table__th--collapsible': true,
		'ds-multi-layer-table__th--collapse': isTableCollapsed
	})

	const isColumnActive = (headerKey) => {
		if (sortConfig.secondaryKey) {
			return headerKey === sortConfig.secondaryKey;
		}
		return headerKey === sortConfig.primaryKey;
	};

	return (
		<div className="ds-multi-layer-table__tr ds-multi-layer-table__tr--thead">
			<div className={collapsibleClass} onClick={toggleTableCollapse} data-testid="collapse-toggle-icon">
				<Icon name="chevron-down" style="solid" size="medium" />
			</div>

			{headers?.map((header, index) => {

				const isSticky = index >= headers.length - stickyColumns;

				const headerClass = classname(
					'ds-multi-layer-table__th',
					{
						sortable: header.sortable !== false,
						'ds-multi-layer-table__th--active': isColumnActive(header.key)
					},
					isSticky ? 'ds-multi-layer-table--sticky-column' : ''
				);

				const uniqueid = uniqueId('th-');
				const googleAnalyticsId = id ? `${id}${header?.label?.toLowerCase()?.replaceAll(/\s+/g, '-')}` : undefined;

				return (
					<div
						className={headerClass}
						key={uniqueid}
						style={{
							flex: `1 1 ${header.width || '150px'}`
						}}
					>
						<div className="ds-multi-layer-table__th__content"
							onClick={() => header.sortable !== false && onSort(header.key)}
							id={googleAnalyticsId}
						>
							<div className="ds-multi-layer-table__th__label" id={googleAnalyticsId}>
								{header.label}
							</div>
							<div className="ds-multi-layer-table__th__sort">
								{header.sortable !== false && getSortIcon(header.key)}
							</div>
						</div>
					</div>
				)
			})}
		</div>
	);
};

MultiLayerHeader.propTypes = {
	headers: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			width: PropTypes.string,
			sortable: PropTypes.bool,
		})
	).isRequired,
	sortConfig: PropTypes.shape({
		primaryKey: PropTypes.string.isRequired,
		primaryDirection: PropTypes.oneOf(['asc', 'desc']).isRequired,
		secondaryKey: PropTypes.string,
		secondaryDirection: PropTypes.oneOf(['asc', 'desc']),
	}).isRequired,
	onSort: PropTypes.func.isRequired,
	groupBy: PropTypes.string.isRequired,
	isTableCollapsed: PropTypes.bool.isRequired,
	toggleTableCollapse: PropTypes.func.isRequired,
	stickyColumns: PropTypes.number,
	id: PropTypes.string
};

export default MultiLayerHeader;
